gsap.registerPlugin(ScrollToPlugin);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function anchorSmoothScroll() {
  const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-bottom-position-desktop'));

  const EXCLUDED_ANCHOR_LINKS = ['#recover', '#login', '#MainContent', '[data-nav-link]'];
  const initAnchor = anchor => {
    if (anchor.dataset.initialized) return;

    if (!/^#\D/.test(anchor.hash) || EXCLUDED_ANCHOR_LINKS.includes(anchor.hash)) return;

    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      // Calculate scroll duration based on distance to target
      const anchorEl = document.querySelector(anchor.hash);
      const shift = anchorEl.offsetTop - window.scrollY;
      const distance = Math.abs(shift);
      // Clamp duration to prevent scrolling too fast or slow
      const duration = clamp(300, distance, 1200) / 1000;

      document.body.classList.add('is-untouchable');

      gsap.to(window, {
        duration,
        ease: 'power2.inOut',
        scrollTo: {
          y: anchorEl,
          offsetY: headerHeight,
        },
        onComplete: () => document.body.classList.remove('is-untouchable'),
      });
    });
    anchor.dataset.initialized = true;
  };
  document.querySelectorAll(`a[href^="#"], a[href^="${window.location.pathname}#"]`).forEach(initAnchor);
}

document.addEventListener('DOMContentLoaded', function () {
  anchorSmoothScroll()
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  // preventScroll stops iOS Safari from scrolling the focused element into
  // view, which otherwise drags the fixed/transformed drawer sideways.
  elementToFocus.focus({ preventScroll: true });

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    this.inputResize();
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
    this.inputResize();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }

  inputResize() {
    this.input.addEventListener('input', resizeInput);
    resizeInput.call(this.input);

    function resizeInput() {
      this.style.width = this.value.length + "ch";
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector):not(.newsletter-form__button)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
    document.body.classList.remove('overflow-hidden');
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.type = 'dialog';
    this.overlay = this.getOverlay();
    this.zoomControls = this.querySelectorAll('zoom-controls, slider-zoom-controls');
    this.handleHide = this.hide.bind(this);
    this.handleKeyUp = this.onKeyUp.bind(this);
    this.handleClick = this.onClick.bind(this);
    this.handlePointerUp = this.onPointerUp.bind(this);
    this.handleTimelineStart = this.onStateChange.bind(this, true);
    this.handleTimelineReverseComplete = this.onStateChange.bind(this, false);
  }

  connectedCallback() {
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.handleHide);
    this.addEventListener('keyup', this.handleKeyUp);

    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', this.handlePointerUp);
    } else {
      this.addEventListener('click', this.handleClick);
    }

    if (this.moved) {
      this.buildTimeline();
    } else {
      // Remove duplicates in theme editor
      if (Shopify.designMode && this.id) {
        const duplicateModals = Array.from(
          document.querySelectorAll(`${this.tagName}#${this.id}`)
        ).filter(modal => modal !== this);

        duplicateModals.forEach(duplicate => duplicate.remove());
      }

      this.moved = true;
      document.body.appendChild(this);
    }
  }

  disconnectedCallback() {
    this.timeline?.kill();
    this.querySelector('[id^="ModalClose-"]').removeEventListener('click', this.handleHide);
    this.removeEventListener('keyup', this.handleKeyUp);

    if (this.classList.contains('media-modal')) {
      this.removeEventListener('pointerup', this.handlePointerUp);
    } else {
      this.removeEventListener('click', this.handleClick);
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') this.hide();
  }

  onClick(event) {
    if (event.target === this) this.hide();
  }

  onPointerUp(event) {
    if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) {
      this.hide();
    }
  }

  buildTimeline() {
    if (this.timeline) this.timeline.kill();

    this.timeline = gsap
      .timeline({
        paused: true,
        onStart: this.handleTimelineStart,
        onReverseComplete: this.handleTimelineReverseComplete,
      })
      .from(this.firstElementChild, {
        scale: 0.7,
        autoAlpha: 0,
        duration: 0.2,
        ease: 'power1.inOut',
      });

    if (this.isOpen()) {
      this.timeline.progress(1);
    }
  }

  onStateChange(open = true) {
    this.updateAttributes(open, true);

    publish(PUB_SUB_EVENTS[open ? 'modal-show' : 'modal-hide'], {
      data: {
        trigger: this.openedBy,
        modal: this,
      },
    });
  }

  updateAttributes(open = true, stateChange = false) {
    document.body.classList.toggle('overflow-hidden', open);
    document.body.classList.toggle('has-open-modal', open);

    if (this.overlay) {
      document.body.classList.toggle(`has-open-${this.type}`, open);
    }

    this.toggleAttribute('open', open);

    if (stateChange) {
      if (open) {
        setTimeout(() => {
          trapFocus(this, this.querySelector('[role="dialog"]'));
        }, 100);
      } else {
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
      }
    }
  }

  getOverlay() {
    const overlay = document.querySelector('[data-modal-overlay]');

    if (overlay) return overlay;

    const overlayElement = document.createElement('div');
    overlayElement.classList.add('modal-overlay', 'modal-overlay--primary');
    overlayElement.dataset.modalOverlay = true;
    document.body.appendChild(overlayElement);

    return overlayElement;
  }

  isOpen() {
    return this.hasAttribute('open');
  }

  animate(open = true) {
    this.zoomControls.forEach(zoom => zoom.reset());

    if (open) {
      this.timeline?.play();
    } else {
      this.timeline?.reverse();
    }
  }

  show(opener) {
    this.openedBy = opener;

    this.overlay?.addEventListener('click', this.handleHide);

    const popup = this.querySelector('.template-popup');
    if (popup) popup.loadContent();

    window.pauseAllMedia();
    this.animate(true);
  }

  hide() {
    this.overlay?.removeEventListener('click', this.handleHide);

    document.body.classList.remove(`has-open-${this.type}`);

    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    this.animate(false);
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalDrawer extends ModalDialog {
  constructor() {
    super();
  }

  buildTimeline() {
    if (this.timeline) this.timeline.kill();

    this.timeline = gsap
      .timeline({
        paused: true,
        onStart: this.handleTimelineStart,
        onReverseComplete: this.handleTimelineReverseComplete,
      })
      .from(this.firstElementChild, {
        xPercent: 100,
        duration: 0.5,
        ease: 'power2.inOut',
      });

    if (this.isOpen()) {
      this.timeline.progress(1);
    }
  }
}
customElements.define('modal-drawer', ModalDrawer);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('responsive-video, video, model-viewer, iframe'),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == 'VIDEO' &&
        deferredElement.getAttribute('autoplay')
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class ResponsiveVideo extends HTMLElement {
  constructor() {
    super();
    this.mobileMQ = window.matchMedia('(max-width: 639.9px)');
    this.posterSources = {
      desktop:
        this.getAttribute('poster') ?? this.videoElement.getAttribute('poster'),
      mobile: this.getAttribute('poster-mobile'),
    };
  }

  connectedCallback() {
    this.bindSourceEvents();

    if (!this.videoElement.hasAttribute('controls')) {
      this.videoElement.addEventListener('click', this.togglePlay.bind(this));
    }

    this.updatePoster();
  }

  disconnectedCallback() {
    this.unbindSourceEvents();

    if (!this.videoElement.hasAttribute('controls')) {
      this.videoElement.removeEventListener(
        'click',
        this.togglePlay.bind(this),
      );
    }
  }

  get videoElement() {
    return (
      this.querySelector('video') ??
      this.querySelector('template').content.querySelector('video')
    );
  }

  get sourceElements() {
    return [...this.videoElement.querySelectorAll('source')];
  }

  togglePlay() {
    if (this.videoElement.paused) {
      this.videoElement.play();
    } else {
      this.videoElement.pause();
    }
  }

  bindSourceEvents() {
    if (this.boundSourceEvents?.size > 0) this.unbindSourceEvents();

    this.boundSourceEvents = [];
    this.sourceElements.forEach(source => {
      if (!source.media) return;
      const target = window.matchMedia(source.media);
      const callback = this.onSourceBreakpoint.bind(this, source);
      this.boundSourceEvents.push({ target, callback });
      target.addEventListener('change', callback);
    });
  }

  unbindSourceEvents() {
    this.boundSourceEvents.forEach(({ target, callback }) => {
      target.removeEventListener('change', callback);
    });
  }

  reload() {
    this.reloadQueued = true;
    const { currentTime, paused } = this.videoElement;
    this.videoElement.addEventListener(
      'loadeddata',
      () => {
        this.videoElement.currentTime = currentTime.toString();
        this.reloadQueued = false;
        if (paused) this.videoElement.pause();
        this.updatePoster();
      },
      { once: true },
    );
    if (this.posterSources.mobile) {
      this.videoElement.removeAttribute('poster');
    }
    this.videoElement.load();
  }

  shouldReload(triggerSource, { matches }) {
    if (this.reloadQueued) return false;
    const currentSrc = this.videoElement.currentSrc.split('/').pop();
    const triggerSrc = triggerSource.src.split('/').pop();
    if (
      (!matches && currentSrc !== triggerSrc) ||
      (matches && currentSrc === triggerSrc)
    )
      return false;

    const currentSourceElement = this.sourceElements.find(
      s => s.src === this.videoElement.currentSrc,
    );

    if (
      matches &&
      currentSourceElement?.dataset.id === triggerSource.dataset.id
    )
      return false;

    return true;
  }

  updatePoster() {
    if (!this.posterSources.desktop) return;

    this.videoElement.setAttribute('poster', this.poster);
  }

  get isMobile() {
    return this.mobileMQ.matches;
  }

  get poster() {
    const { mobile, desktop } = this.posterSources;

    if (!mobile) return desktop;

    return this.isMobile ? mobile : desktop;
  }

  onSourceBreakpoint(source, event) {
    if (this.videoElement.readyState === 0) {
      this.updatePoster();
      return;
    }

    if (this.shouldReload(source, event)) {
      this.reload();
    }
  }
}

customElements.define('responsive-video', ResponsiveVideo);

// class SliderComponent extends HTMLElement {
//   constructor() {
//     super();
//     this.slider = this.querySelector('[id^="Slider-"]');
//     this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
//     this.enableSliderLooping = false;
//     this.currentPageElement = this.querySelector('.slider-counter--current');
//     this.pageTotalElement = this.querySelector('.slider-counter--total');
//     this.prevButton = this.querySelector('button[name="previous"]');
//     this.nextButton = this.querySelector('button[name="next"]');

//     if (!this.slider || !this.nextButton) return;

//     this.initPages();
//     const resizeObserver = new ResizeObserver((entries) => this.initPages());
//     resizeObserver.observe(this.slider);

//     this.slider.addEventListener('scroll', this.update.bind(this));
//     this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
//     this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
//   }

//   initPages() {
//     this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
//     if (this.sliderItemsToShow.length < 2) return;
//     this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
//     this.slidesPerPage = Math.floor(
//       (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
//     );
//     this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
//     this.update();
//   }

//   resetPages() {
//     this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
//     this.initPages();
//   }

//   update() {
//     // Temporarily prevents unneeded updates resulting from variant changes
//     // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
//     if (!this.slider || !this.nextButton) return;

//     const previousPage = this.currentPage;
//     this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

//     if (this.currentPageElement && this.pageTotalElement) {
//       this.currentPageElement.textContent = this.currentPage;
//       this.pageTotalElement.textContent = this.totalPages;
//     }

//     if (this.currentPage != previousPage) {
//       this.dispatchEvent(
//         new CustomEvent('slideChanged', {
//           detail: {
//             currentPage: this.currentPage,
//             currentElement: this.sliderItemsToShow[this.currentPage - 1],
//           },
//         })
//       );
//     }

//     if (this.enableSliderLooping) return;

//     if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
//       this.prevButton.setAttribute('disabled', 'disabled');
//     } else {
//       this.prevButton.removeAttribute('disabled');
//     }

//     if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
//       this.nextButton.setAttribute('disabled', 'disabled');
//     } else {
//       this.nextButton.removeAttribute('disabled');
//     }
//   }

//   isSlideVisible(element, offset = 0) {
//     const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
//     return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     const step = event.currentTarget.dataset.step || 1;
//     this.slideScrollPosition =
//       event.currentTarget.name === 'next'
//         ? this.slider.scrollLeft + step * this.sliderItemOffset
//         : this.slider.scrollLeft - step * this.sliderItemOffset;
//     this.slider.scrollTo({
//       left: this.slideScrollPosition,
//     });
//   }
// }

// customElements.define('slider-component', SliderComponent);

class GridLayout extends HTMLElement {
  constructor() {
    super();

    this.columnCount = {
      min: parseInt(this.getAttribute('columns-min'), 10),
      max: parseInt(this.getAttribute('columns-max'), 10),
    };
    this.columnMinWidth = this.getAttribute('column-min-width');

    this.build();

    this.gridStyles = getComputedStyle(this.grid);
    this.mm = window.matchMedia('(max-width: 1099px)');

    this.debouncedUpdateGrid = debounce(this.updateGrid.bind(this), RESIZE_DEBOUNCE_TIMER);
  }

  build() {
    this.setAttribute('class', 'page-width');
    this.grid = document.createElement('ul');
    this.grid.setAttribute('class', 'grid product-grid');
    this.grid.dataset.columnsMobile = this.columnCount.min;
    this.grid.dataset.columns = this.columnCount.max;

    this.appendChild(this.grid);

    for (let i = 1; i <= this.columnCount.max; i++) {
      const gridItem = document.createElement('li');
      this.grid.appendChild(gridItem);
    }
  }

  connectedCallback() {
    window.addEventListener('resize', this.debouncedUpdateGrid);

    if (this.mm.matches) {
      window.addEventListener('load', this.debouncedUpdateGrid);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedUpdateGrid);
    window.removeEventListener('load', this.debouncedUpdateGrid);
  }

  updateGrid() {
    if (this.mm.matches) {
      const contentWidth = parseFloat(this.gridStyles.getPropertyValue('width'));
      const gridSpacing = parseFloat(this.gridStyles.getPropertyValue('column-gap'));
      const columnRange = range(this.columnCount.min, this.columnCount.max).reverse();

      for (const count of columnRange) {
        const spacing = (count - 1) * gridSpacing;
        const width = (contentWidth - spacing) / count;

        if (width < this.columnMinWidth && count !== columnRange[columnRange.length - 1]) continue;

        document.documentElement.style.setProperty('--product-grid-columns', count);
        break;
      }
    } else if (document.documentElement.style.getPropertyValue('--product-grid-columns')) {
      this.resetGrid();
    }

    this.dispatchEvent(new CustomEvent('grid-update'));
  }

  resetGrid() {
    document.documentElement.style.removeProperty('--product-grid-columns');
  }
}

customElements.define('grid-layout', GridLayout);

// TODO: Add "loop" attribute and implement?
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
    this.sliderControlWrapper = this.querySelector('.slider__control-wrapper');
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper?.querySelectorAll('.slider-counter__link') ?? []);
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.debouncedResize = debounce(entries => this.initPages(), RESIZE_DEBOUNCE_TIMER);
    this.handleOrientationChange = this.changeOrientation.bind(this);
  }

  connectedCallback() {
    if (!this.slider) return;

    this.initOrientation();

    if (this.constructor.name !== 'ProductSlider') {
      this.initPages();
    }

    this.resizeObserver = new ResizeObserver(this.debouncedResize.bind(this));
    this.resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.prevButton?.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton?.addEventListener('click', this.onButtonClick.bind(this));
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.slider.removeEventListener('scroll', this.update.bind(this));
    this.sliderControlLinksArray.forEach(link => link.removeEventListener('click', this.linkToSlide.bind(this)));
    this.prevButton?.removeEventListener('click', this.onButtonClick.bind(this));
    this.nextButton?.removeEventListener('click', this.onButtonClick.bind(this));
    this.orientationMQL?.removeEventListener('change', this.handleOrientationChange);
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length > 0) this.currentPage ??= 1;
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1][this.measurement.offset] - this.sliderItemsToShow[0][this.measurement.offset];
    this.slidesPerPage = Math.floor((this.slider[this.measurement.size] - this.sliderItemsToShow[0][this.measurement.offset]) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  initOrientation() {
    this.verticalTarget = this.getAttribute('vertical') ?? false;

    switch (this.verticalTarget) {
      case 'true':
        this.isVertical = true;
        break;
      case false:
        this.isVertical = false;
        break;
      default:
        const queryString = mediaQueryString(this.verticalTarget);

        if (!queryString) {
          this.isVertical = false;
          break;
        }

        this.orientationMQL = window.matchMedia(queryString);
        this.orientationMQL.addEventListener('change', this.handleOrientationChange);
        this.isVertical = this.orientationMQL.matches;
        break;
    }

    this.updateOrientation();
  }

  // TODO: Clean up orientation handling & language
  changeOrientation(e) {
    this.isVertical = e.matches;
    this.updateOrientation();
  }

  updateOrientation() {
    this.slider.classList.toggle('is-vertical', this.isVertical);
    this.measurement = {
      scroll: this.isVertical ? 'scrollTop' : 'scrollLeft',
      offset: this.isVertical ? 'offsetTop' : 'offsetLeft',
      size: this.isVertical ? 'clientHeight' : 'clientWidth',
    };
  }

  updatePagination() {
    this.sliderControlLinksArray.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlLinksArray[this.currentPage - 1]?.classList.add('slider-counter__link--active');
    this.sliderControlLinksArray[this.currentPage - 1]?.setAttribute('aria-current', true);
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider[this.measurement.scroll] / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    this.updatePagination();

    if (this.enableSliderLooping) return;

    if (this.prevButton) {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider[this.measurement.scroll] === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
    }

    if (this.nextButton) {
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider[this.measurement.size] + this.slider[this.measurement.scroll] - offset;
    return (element[this.measurement.offset] + element[this.measurement.size]) <= lastVisibleSlide && element[this.measurement.offset] >= this.slider[this.measurement.scroll];
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider[this.measurement.scroll] + (step * this.sliderItemOffset) : this.slider[this.measurement.scroll] - (step * this.sliderItemOffset);

    const direction = this.isVertical ? 'top' : 'left';
    this.slider.scrollTo({
      [direction]: this.slideScrollPosition,
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider[this.measurement.scroll] + this.sliderFirstItemNode[this.measurement.size] * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);

    const direction = this.isVertical ? 'top' : 'left';
    this.slider.scrollTo({
      [direction]: slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

// TODO: Update pagination to show all visible slides as active (figure out click event)
class CardSlider extends SliderComponent {
  constructor() {
    super();
    this.gridLayout = document.querySelector('grid-layout');
    this.onGridUpdate = this.updateGrid.bind(this);
    this.disableAnimations = this.hasAttribute('disable-animations');
  }

  connectedCallback() {
    super.connectedCallback();
    this.gridLayout.addEventListener('grid-update', this.onGridUpdate);
    // TODO: Consider implementing this on standard slider
    this.initObserver();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.gridLayout.removeEventListener('grid-update', this.onGridUpdate);
    this.observer.disconnect();
  }

  static get observedAttributes() {
    return ['aria-hidden'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'aria-hidden') {
      if (!this.isHidden()) {
        this.updateGrid();
      }
    }
  }

  initObserver() {
    this.observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          this.resetPages();
        }
      }
    });

    this.observer.observe(this.slider, {
      childList: true,
    });
  }

  initPages() {
    if (!this.isActive()) {
      if (this.initialized) this.reset();

      return;
    }

    if (this.isHidden()) return;

    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      element => element.clientWidth > 0
    );

    this.slider.classList.toggle('is-active', this.isActive());

    if (this.sliderItemsToShow.length < 2) return;

    if (!this.initialized) this.init();

    this.update();
  }

  // TODO: Consider implementing orientation support (see SliderComponent)
  updateSliderVars() {
    this.sliderOffset = this.sliderItemsToShow[0].offsetLeft;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.sliderGap = this.sliderItemOffset - this.sliderItemsToShow[1].clientWidth;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderOffset * 2 + this.sliderGap) / this.sliderItemOffset + 0.1
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
  }

  updateGrid() {
    if (!this.initialized) return;
    this.updateSliderVars();

    if (this.disableAnimations) return;
    if (this.mm.contexts[0].conditions.matches) {
      this.sliderItemsToShow.forEach(slide => {
        this.updateSlideVisibility(slide);
      });

      this.refreshTimelines();
    }
  }

  updatePagination() {
    this.sliderControlLinksArray.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });

    let currentIndex = this.currentPage - 1;
    this.sliderControlLinksArray[currentIndex]?.setAttribute('aria-current', true);

    for (let i = 0; i < this.slidesPerPage; i++) {
      this.sliderControlLinksArray[currentIndex + i]?.classList.add('slider-counter__link--active');
    }
  }

  reset() {
    this.mm.revert();
    this.timelines = [];
    this.initialized = false;
  }

  init() {
    this.initialized = true;
    this.mm = gsap.matchMedia();
    this.updateSliderVars();
    if (!this.disableAnimations) this.createTimelines();

    this.dispatchEvent(new CustomEvent('sliderInitialized', {
      detail: {
        currentPage: this.currentPage,
        currentElements: this.currentElements,
        currentElement: this.currentElement,
      }
    }));
  }

  isActive() {
    return this.slider.scrollWidth > this.slider.clientWidth;
  }

  isHidden() {
    return this.getAttribute('aria-hidden') === 'true';
  }

  updateSlideVisibility(slide, card) {
    card ??= slide.querySelector('.card-wrapper');
    const isHidden = !this.isSlideVisible(slide);

    card.classList.toggle('is-hidden', isHidden);

    if (isHidden) {
      gsap.set(card, { opacity: 0, scale: 0.95 });
    } else {
      gsap.set(card, { opacity: 1, scale: 1 });
    }
  }

  createTimelines() {
    // TODO: Replace with context and apply at all breakpoints! (mobile has extra item peeking)
    this.mm.add('(min-width: 1100px)', () => {
      this.timelines = [];

      this.sliderItemsToShow.forEach(slide => {
        const card = slide.querySelector('.card-wrapper');

        this.updateSlideVisibility(slide, card);

        this.timelines.push(
          gsap
            .timeline({
              scrollTrigger: {
                trigger: slide,
                scroller: this.slider,
                horizontal: true,
                scrub: true,
                start: () => `left right-=${this.sliderOffset}px`,
                end: () => `right left+=${this.sliderOffset}px`,
              },
            })
            .to(card, {
              opacity: 1,
              scale: 1,
              ease: 'power1.in',
              onComplete: () => {
                card.classList.remove('is-hidden');
              },
            })
            .to(
              card,
              {
                opacity: 0,
                scale: 0.95,
                ease: 'power1.out',
                onComplete: () => {
                  card.classList.add('is-hidden');
                },
              },
              '+=2'
            )
        );
      });
    });
  }

  disableTimelines() {
    this.timelines.forEach(timeline => timeline.scrollTrigger?.disable());
  }

  enableTimelines() {
    this.timelines.forEach(timeline => timeline.scrollTrigger?.enable());
  }

  toggleTimelines(enable) {
    if (enable) {
      this.enableTimelines();
    } else {
      this.disableTimelines();
    }
  }

  refreshTimelines() {
    this.timelines.forEach(timeline => {
      timeline.scrollTrigger?.refresh();
    });
  }

  // TODO: Consider implementing orientation support (see SliderComponent)
  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth +
      this.slider.scrollLeft +
      this.sliderGap -
      this.sliderOffset -
      offset;

    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft + this.sliderOffset
    );
  }
}

customElements.define('card-slider', CardSlider);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, { once: true });
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.productOptionKeys = JSON.parse(this.dataset.options);
    this.productFormId = this.dataset.formId;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();

      // At least one option is undefined
      if (this.options.filter(Boolean).length < this.optionElements.length) {
        this.getPartialVariantMatch();
        this.updateMedia(true);
        this.renderProductInfo(true);
      }
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.optionElements = Array.from(this.querySelectorAll('select'));
    this.options = Array.from(this.optionElements, (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    document.dispatchEvent(new CustomEvent('variantUpdated', { bubbles: true, detail: { variant_id: this.currentVariant, product_form_id: this.productFormId } }));
  }

  getPartialVariantMatch() {
    this.partialVariant = this.getVariantData().find(variant => {
      for (const [index, option] of this.options.entries()) {
        if (typeof option === 'undefined') continue;
        if (variant.options[index] !== option) return false;
      }
      return true
    })
  }

  updateMedia(partialVariant = false) {
    const requestedVariant = partialVariant ? this.partialVariant : this.currentVariant;

    if (!requestedVariant) return;
    if (!requestedVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${requestedVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${requestedVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  get formId() {
    this._formId ??= this.dataset.formId;
    return this._formId;
  }

  get fieldsets() {
    return [...this.querySelectorAll('.product-form__input')]
  }

  updateVariantStatuses() {
    const optionOneKey = this.productOptionKeys[0]
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(`[data-option-key="${optionOneKey}"]:checked`).value === variant.option1
    );
    const inputWrappers = this.fieldsets.reduce((acc, fieldset) => ({ ...acc, [fieldset.dataset.productOption]: fieldset }), {});
    Object.entries(inputWrappers).forEach(([optionKey, option]) => {
      // const optionKey = option.dataset.productOption;
      const index = this.productOptionKeys.indexOf(optionKey)
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[this.productOptionKeys[index - 1]].querySelector(':checked')?.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue, optionKey);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      if ("fetchAvailability" in pickUpAvailability) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      }
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo(partialVariant = false) {
    const requestedVariant = partialVariant ? this.partialVariant : this.currentVariant;
    const requestedVariantId = requestedVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (requestedVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        if (!partialVariant) {
          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            window.variantStrings.soldOut,
            true,
            this.currentVariant.id
          );
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: requestedVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true, variantID) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) {
        addButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      addButton.removeAttribute('data-no-variant-selected');
      document.querySelector(".product-form__warning-message")?.remove();

      if (this.dataset.modifyForm === 'true') {
        addButtonText.textContent = window.variantStrings.confirmModify;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);

    if (!button) return;

    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.select_size;
    addButton.setAttribute('data-no-variant-selected', true);
    addButton.removeAttribute('disabled');

    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const disabled = !listOfAvailableOptions.includes(
        input.getAttribute('value'),
      );
      input.classList.toggle('disabled', disabled);
      const label = document.querySelector(`label[for="${input.id}"]`);
      input.setAttribute(
        'aria-label',
        `${input.dataset.labelPrefix} ${label
          .querySelector('.option-value')
          .textContent.trim()} ${
          disabled ? window.variantStrings.unavailable_suffix : ''
        }`.trim(),
      );
    });
  }

  updateOptions() {
    this.optionElements = Array.from(this.querySelectorAll('fieldset'));
    this.options = this.optionElements.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class QuickShopVariantRadios extends VariantRadios {
  constructor() {
    super();

    const addToCart = this.dataset.addToCart;
    this.atcEnabled = !!addToCart && addToCart !== 'false';
  }

  updateOptions() {

    //need to catch color option to change color URL property
    let isColorOption = false;

    this.mappedOptions = this.fieldsets.reduce((acc, fieldset) => {
      for (const radio of [...fieldset.querySelectorAll('input')]) {
        if (radio.checked) {

          if(radio.getAttribute('data-option-key') == 'color') {
            isColorOption = radio
          }

          acc[radio.dataset.optionKey] = radio.value;
          break;
        }
      }

      return acc
    }, Object.fromEntries(this.productOptionKeys.map(key => [key, null])))
    this.options = this.productOptionKeys.map(key => this.mappedOptions[key])
    this.changeCardFeaturedImage();

    if(isColorOption) this.updateColorProperty(isColorOption)
  }

  updateColorProperty(radio) {

    const parent = radio.closest('.card__content')
    const colorValue = radio.value

    const currentLink = parent.querySelector('.card__heading a')
    const currentHref = currentLink?.getAttribute('href')

    if(currentHref.includes('color')) {
      let splitted = currentHref?.split('color=')
      currentLink.setAttribute('href', splitted[0]+'color='+colorValue)
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          const key = this.productOptionKeys[index]

          // Accept any size value if ATC is disabled
          if (!this.atcEnabled && key === 'size') return true

          return this.options[index] === option;
        })
        .includes(false);
    });
    document.dispatchEvent(new CustomEvent('variantUpdated', { bubbles: true, detail: { variant_id: this.currentVariant } }));
  }

  handleImageSrc(src) {
    if (!this.imageSrcPattern) {
      const imageSrcBase = window.Shopify.cdnHost.replace('/cdn', '');
      this.imageSrcPattern ??= new RegExp(`^(?:(?:https?:)?\\/\\/${imageSrcBase.replaceAll(/([\^\$\.\*\+\?\(\)\[\]\{\}\|\/])/g, '\\$1')})?(.*)`)
    }

    return src.replace(this.imageSrcPattern, '$1');
  }

  replaceImage(target, imageData) {
    if (!target || !imageData) return;

    this.currentSrcPattern ??= /(?<currentSrc>.*)&width=(?<width>\d+)/

    const currentSrcMatch = target.getAttribute('src').match(this.currentSrcPattern);
    const { currentSrc, width } = currentSrcMatch?.groups ?? { currentSrc: target.getAttribute('src') };
    const rawSrc = this.handleImageSrc(imageData.preview_image.src);
    const src = `${rawSrc}${width ? `&width=${width}` : ''}`
    const srcset = target.getAttribute('srcset').replaceAll(currentSrc, rawSrc);

    const imageElement = new Image();
    imageElement.onload = () => {
      target.replaceWith(imageElement);
    }
    imageElement.alt = imageData.alt;
    imageElement.className = target.className;
    imageElement.setAttribute('width', target.getAttribute('width'));
    imageElement.setAttribute('height', target.getAttribute('height'));
    imageElement.srcset = srcset;
    imageElement.src = src;
  }

  changeCardFeaturedImage() {
    const targetImages = [
      ...this.closest('.card--media').querySelectorAll('.card__media img'),
    ];
    let selectedVariant;

    if (this.options[1]) {
      selectedVariant = this.getVariantData().filter((variant) => variant.option1 === this.options[0] && variant.option2 === this.options[1]);
    } else {
      selectedVariant = this.getVariantData().filter(
        variant => variant.option1 === this.options[0],
      );
    }

    const variantMedia = this.getVariantMedia(this.mappedOptions.color);

    if (variantMedia?.primary?.preview_image?.src) {
      this.replaceImage(targetImages[0], variantMedia.primary);
    }

    if (targetImages[1] && variantMedia?.secondary?.preview_image?.src) {
      this.replaceImage(targetImages[1], variantMedia.secondary);
    }

    if (selectedVariant.length === 0) return;

    const card = this.closest('.card--media');
    const cardLinks = card.querySelectorAll('a:not([data-size-link])');

    cardLinks.forEach((link) => {
      const linkHref = new URL(link.getAttribute('href'), window.location.origin);
      const variantId = selectedVariant[0].id;

      if (linkHref.searchParams.has('variant')) {
        linkHref.searchParams.set('variant', variantId);
      } else {
        linkHref.searchParams.append('variant', variantId);
      }

      link.setAttribute('href', linkHref.toString());
    });
  }

  getVariantMedia(color = null) {
    this.variantMedia =
      this.variantMedia ||
      JSON.parse(
        this.querySelector('[type="application/json"][data-variants-media]')
          .textContent,
      );
    return color ? this.variantMedia[color] : this.variantMedia;
  }

  // Override because we don't want to update the URL
  updateURL() {}

  // Override because we don't want to update the variant input
  updatePickupAvailability() {}

  toggleAddButton(disable = true, text) {
    if (!this.addButton) return;

    if (text) {
      const addButtonText = this.addButton.querySelector('span');
      addButtonText.textContent = text;
    }

    if (disable) {
      this.addButton.setAttribute('disabled', 'disabled');
    } else {
      this.addButton.removeAttribute('disabled');
    }
  }

  get card() {
    this._card ??= this.closest('.card');
    return this._card;
  }

  get productForm() {
    this._productForm ??= document.getElementById(`product-form-${this.formId}`);
    return this._productForm;
  }

  get fieldsetSelector() {
    return `fieldset[data-form-id="${this.formId}"]`
  }

  get fieldsets() {
    return [...document.querySelectorAll(this.fieldsetSelector)]
  }

  get addButton() {
    if (!this.productForm) return null;
    this._addButton ??= this.productForm.querySelector('[name="add"]');
    return this._addButton;
  }

  get sizeLinks() {
    return [...document.querySelectorAll(`${this.fieldsetSelector} [data-size-link]`)]
  }

  updateNotifyButton() {
    // TODO: consider utilizing this for the Klaviyo integration
    // this.currentVariant.id;
  }

  updateSizeLinks() {
    const sizeLinks = this.sizeLinks;
    const variantData = this.getVariantData()

    for (const link of this.sizeLinks) {
      const size = link.dataset.size;
      const options = this.options.with(this.productOptionKeys.indexOf('size'), size);
      const variant = variantData.find(
        variant =>
          !variant.options
            .map((option, index) => options[index] === option)
            .includes(false)
      )

      link.classList.toggle('is-disabled', !variant?.available)

      if (variant) {
        const linkHref = new URL(link.getAttribute('href'), window.location.origin);

        if (linkHref.searchParams.has('variant')) {
          linkHref.searchParams.set('variant', variant.id);
        } else {
          linkHref.searchParams.append('variant', variant.id);
        }

        link.setAttribute('href', linkHref.toString());
      }
    }
  }

  renderProductInfo() {
    const requestedVariant = this.currentVariant;

    this.updateNotifyButton();
    if (requestedVariant.available) {
      this.toggleAddButton(false, 'Add to bag');
    } else {
      this.toggleAddButton(true, 'Sold Out');
    }

    function formatPrice(price) {
      return price / 100 + ' ' + window.Shopify.currency.active;
    }

    const priceContainer = this.closest('.card').querySelector('.card__information .price');
    const regularPrice = priceContainer.querySelector('.price__regular');
    const salePrice = priceContainer.querySelector('.price__sale');

    if (requestedVariant.compare_at_price > requestedVariant.price) {
      priceContainer.classList.add('price--on-sale');
      salePrice.querySelector('.price-item--regular').textContent = formatPrice(requestedVariant.compare_at_price);
      salePrice.querySelector('.price-item--sale').textContent = formatPrice(requestedVariant.price);
    } else {
      priceContainer.classList.remove('price--on-sale');
      regularPrice.querySelector('.price-item').textContent = formatPrice(requestedVariant.price);
    }

    if (!this.atcEnabled) this.updateSizeLinks();
  }
}

customElements.define('quick-shop-variant-radios', QuickShopVariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
            this.querySelectorAll('script').forEach((oldScriptTag) => {
              const newScriptTag = document.createElement('script');
              Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
              });
              newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
              oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function initHeader() {
  const headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;

  const isTransparent = headerWrapper.classList.contains('header-wrapper--transparent');
  const scrollThreshold = 50;

  // Expose header height as a CSS variable for layout that depends on it.
  function updateHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${headerWrapper.offsetHeight}px`);
  }
  window.addEventListener('resize', updateHeaderHeight);
  updateHeaderHeight();

  // ============================================
  // Sticky / Transparent on scroll
  // ============================================

  let isScrolled = false;

  function setScrolled(value) {
    if (value === isScrolled) return;
    isScrolled = value;
    headerWrapper.classList.toggle('header-wrapper--scrolled', value);
  }

  function onScroll() {
    setScrolled(window.scrollY > scrollThreshold);
  }

  window.addEventListener('scroll', onScroll, {passive: true});
  onScroll();

  // ============================================
  // Mega Menu
  // ============================================

  const navItems = headerWrapper.querySelectorAll('.js-navMenuParent');

  // Hover has to rest on a nav item this long before its menu opens, so a pointer
  // that only crosses a neighbouring item on its way somewhere (e.g. sideways into
  // the open menu's panel) doesn't open that item's menu and close the current one.
  const hoverOpenDelay = 100;

  function openMegaMenu(navItem) {
    clearTimeout(navItem._openTimeout);
    clearTimeout(navItem._closeTimeout);
    navItems.forEach(item => {
      if (item !== navItem) closeMegaMenu(item, true);
    });
    navItem.classList.add('is-open');
    setScrolled(true);
  }

  function scheduleOpenMegaMenu(navItem) {
    // Back on an item whose menu is still open (or closing): keep it, no delay.
    clearTimeout(navItem._closeTimeout);
    if (navItem.classList.contains('is-open')) return;
    clearTimeout(navItem._openTimeout);
    navItem._openTimeout = setTimeout(() => openMegaMenu(navItem), hoverOpenDelay);
  }

  function closeMegaMenu(navItem, immediate) {
    clearTimeout(navItem._openTimeout);
    const panel = navItem.querySelector('.mega-menu__images');
    if (panel && panel._resetImages) panel._resetImages();

    if (immediate) {
      clearTimeout(navItem._closeTimeout);
      navItem.classList.remove('is-open');
      return;
    }
    clearTimeout(navItem._closeTimeout);
    navItem._closeTimeout = setTimeout(() => {
      navItem.classList.remove('is-open');
      if (!headerWrapper.querySelector('.js-navMenuParent.is-open')) {
        if (!isTransparent || window.scrollY > scrollThreshold) return;
        setScrolled(false);
      }
    }, 150);
  }

  navItems.forEach(navItem => {
    navItem.addEventListener('mouseenter', () => scheduleOpenMegaMenu(navItem));
    navItem.addEventListener('mouseleave', () => closeMegaMenu(navItem, false));
    navItem.addEventListener('focusin', () => openMegaMenu(navItem));
    navItem.addEventListener('focusout', () => closeMegaMenu(navItem, false));

    // ============================================
    // Image swap on hover
    // ============================================

    const imagesPanel = navItem.querySelector('.mega-menu__images');
    if (!imagesPanel) return;

    const slotLeft = imagesPanel.querySelector('[data-image-link="left"]');
    const slotRight = imagesPanel.querySelector('[data-image-link="right"]');

    const defaults = {
      left: {
        src: imagesPanel.dataset.defaultImageLeft,
        caption: imagesPanel.dataset.defaultImageLeftCaption,
        url: imagesPanel.dataset.defaultImageLeftUrl,
      },
      right: {
        src: imagesPanel.dataset.defaultImageRight,
        caption: imagesPanel.dataset.defaultImageRightCaption,
        url: imagesPanel.dataset.defaultImageRightUrl,
      },
    };

    // Render a single slot. Empty src => empty slot.
    function applySlot(slot, side, data) {
      if (!slot || !data) return;

      const src = data.src || '';
      const caption = data.caption || '';
      const alt = caption || data.alt || '';
      const url = data.url || '';

      // Update link href (only when the slot is an anchor)
      if (slot.tagName === 'A') {
        if (url) {
          slot.setAttribute('href', url);
        } else {
          slot.removeAttribute('href');
        }
      }

      // No image: clear the slot entirely
      if (!src) {
        if (slot.firstChild) slot.replaceChildren();
        return;
      }

      // Reuse a plain <img>, or (re)build the slot content
      let img = slot.querySelector('.mega-menu__image');
      const insidePicture = img && img.closest('picture');

      if (!img || insidePicture) {
        img = new Image();
        img.className = `mega-menu__image mega-menu__image--${side}`;
        img.loading = 'lazy';
      }

      if (img.getAttribute('src') !== src) img.src = src;
      img.alt = alt;

      let captionEl = slot.querySelector('.mega-menu__caption');
      if (caption) {
        if (!captionEl) {
          captionEl = document.createElement('p');
          captionEl.className = 'mega-menu__caption';
          captionEl.appendChild(document.createElement('span'));
        }
        const span = captionEl.querySelector('span') || captionEl.appendChild(document.createElement('span'));
        span.textContent = caption;
      } else {
        captionEl = null;
      }

      const next = captionEl ? [img, captionEl] : [img];
      slot.replaceChildren(...next);
    }

    function setImages(left, right) {
      applySlot(slotLeft, 'left', left);
      applySlot(slotRight, 'right', right);
    }

    // Small hover-intent delay so brushing across links on the way to the
    // banner doesn't accidentally swap it in. Cleared as soon as the pointer
    // leaves the link (or the menu resets).
    const HOVER_DELAY = 300;
    let hoverTimer = null;
function clearHoverTimer() {
  if (hoverTimer !== null) clearTimeout(hoverTimer);
  hoverTimer = null;
}

    function resetImages() {
      clearHoverTimer();
      setImages(defaults.left, defaults.right);
    }

    // Targets that swap in their own images (collection links)
    const swapTargets = navItem.querySelectorAll('[data-image-left], [data-image-right]');
    swapTargets.forEach(target => {
      const applyImages = () => {
        setImages(
          {
            src: target.dataset.imageLeft || defaults.left.src,
            caption: target.dataset.imageLeftCaption || '',
            alt: target.dataset.imageLeftAlt || '',
            url: target.dataset.imageLeftUrl || defaults.left.url,
          },
          {
            src: target.dataset.imageRight || defaults.right.src,
            caption: target.dataset.imageRightCaption || '',
            alt: target.dataset.imageRightAlt || '',
            url: target.dataset.imageRightUrl || defaults.right.url,
          }
        );
      };

      // Mouse: wait HOVER_DELAY before swapping; cancel if the pointer leaves first.
      target.addEventListener('mouseenter', () => {
        clearHoverTimer();
        hoverTimer = setTimeout(applyImages, HOVER_DELAY);
      });
      target.addEventListener('mouseleave', clearHoverTimer);

      // Keyboard focus: swap immediately (no delay for accessibility).
      target.addEventListener('focusin', () => {
        clearHoverTimer();
        applyImages();
      });
    });

    imagesPanel._resetImages = resetImages;

    const resetTargets = navItem.querySelectorAll('.header__nav-link');
    resetTargets.forEach(target => {
      target.addEventListener('mouseenter', resetImages);
      target.addEventListener('focusin', resetImages);
    });
  });

  // ============================================
  // Mobile Drawer
  // ============================================

  const drawerToggleBtns = document.querySelectorAll('.js-drawerToggle');
  const drawer = document.getElementById('HeaderDrawer');

  if (drawer) {
    if (Shopify.designMode && drawer.id) {
      document.querySelectorAll(`#${drawer.id}`).forEach(dup => {
        if (dup !== drawer) dup.remove();
      });
    }
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    let lastFocusedBeforeOpen;
    const bodyScroll = document.getElementById('nhd-body-scroll');

    function setPageInert(makeInert) {
      const keep = [drawer];
      const announcementBar = document.querySelector('.announcement-bar-section');
      const header = document.querySelector('.section-header');
      if (announcementBar) keep.push(announcementBar);
      if (header) keep.push(header.closest('body > *') || header);
      Array.from(document.body.children).forEach(child => {
        if (keep.includes(child)) return;
        child.toggleAttribute('inert', makeInert);
      });
    }

    function getFocusable(scope) {
      return Array.from(
        scope.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden]):not([disabled])')
      ).filter(el => el.offsetWidth > 0 || el.offsetHeight > 0);
    }

    function onDrawerKeydown(e) {
      if (e.key === 'Escape') {
        const openSub = drawer.querySelector('.nhd__submenu.is-open');
        if (openSub) {
          closeSubmenu(openSub.id);
        } else {
          closeDrawer();
        }
        return;
      }

      if (e.key !== 'Tab') return;

      const openSubmenu = drawer.querySelector('.nhd__submenu.is-open');

      // Submenu: trap focus within the submenu only (X closes via Escape)
      if (openSubmenu) {
        const focusable = getFocusable(openSubmenu);
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
        return;
      }

      const header = document.querySelector('.section-header');
      const headerItems = header ? getFocusable(header) : [];
      const items = [...headerItems, ...getFocusable(drawer)];
      if (items.length === 0) return;

      const first = items[0];
      const last = items[items.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function openDrawer() {
      lastFocusedBeforeOpen = document.activeElement;

      const bar = document.querySelector('.utility-bar');
      let barHeight = 0;
      if (bar && !bar.classList.contains('is-hidden')) {
        barHeight = Math.min(Math.max(bar.getBoundingClientRect().bottom, 0), bar.offsetHeight);
      }
      // How much of the bar is still on screen, so the drawer opens flush under the
      // header. This gets its own variable: --announcement-bar-height is the bar's
      // full height and is read by layout that must not move when a drawer opens.
      document.documentElement.style.setProperty('--announcement-bar-visible', `${Math.round(barHeight)}px`);

      document.body.classList.add('state--nav-open');
      setPageInert(true);
      drawerToggleBtns.forEach(btn => btn.setAttribute('aria-expanded', 'true'));
      drawer.addEventListener('keydown', onDrawerKeydown);

      drawer.focus();
    }

    function closeDrawer() {
      const openSub = drawer.querySelector('.nhd__submenu.is-open');
      if (openSub) closeSubmenu(openSub.id, true);

      document.body.classList.remove('state--nav-open');
      drawerToggleBtns.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
      drawer.removeEventListener('keydown', onDrawerKeydown);

      setPageInert(false);

      if (lastFocusedBeforeOpen) lastFocusedBeforeOpen.focus();
    }

    function openSubmenu(submenuId) {
      const submenu = document.getElementById(submenuId);
      if (!submenu) return;

      drawer.querySelectorAll('.nhd__submenu.is-open').forEach(open => {
        if (open.id !== submenuId) closeSubmenu(open.id, true);
      });

      submenu.classList.add('is-open');
      submenu.removeAttribute('aria-hidden');
      if (bodyScroll) bodyScroll.setAttribute('aria-hidden', 'true');

      const btn = drawer.querySelector(`[aria-controls="${submenuId}"].js-nhdSubmenuOpen`);
      if (btn) btn.setAttribute('aria-expanded', 'true');

      const backBtn = submenu.querySelector('.js-nhdSubmenuClose');
      if (backBtn) backBtn.focus();
    }

    function closeSubmenu(submenuId, skipFocus) {
      const submenu = document.getElementById(submenuId);
      if (!submenu) return;

      submenu.classList.remove('is-open');
      submenu.setAttribute('aria-hidden', 'true');

      if (bodyScroll && !drawer.querySelector('.nhd__submenu.is-open')) {
        bodyScroll.removeAttribute('aria-hidden');
      }

      const btn = drawer.querySelector(`[aria-controls="${submenuId}"].js-nhdSubmenuOpen`);
      if (btn) btn.setAttribute('aria-expanded', 'false');

      if (!skipFocus && btn) btn.focus();
    }

    const desktopMQ = window.matchMedia('(min-width: 1024px)');
    desktopMQ.addEventListener('change', (e) => {
      if (e.matches && document.body.classList.contains('state--nav-open')) {
        closeDrawer();
      }
    });

    drawerToggleBtns.forEach(btn => btn.addEventListener('click', () => {
      if (!document.body.classList.contains('state--nav-open')) {
        openDrawer();
      } else {
        closeDrawer();
      }
    }));

    drawer.addEventListener('click', e => {
      const closeBtn = e.target.closest('.js-drawerClose');
      if (closeBtn) {
        closeDrawer();
        return;
      }

      const openSubmenuBtn = e.target.closest('.js-nhdSubmenuOpen');
      if (openSubmenuBtn) {
        const submenuId = openSubmenuBtn.getAttribute('aria-controls');
        if (submenuId) openSubmenu(submenuId);
        return;
      }

      const closeSubmenuBtn = e.target.closest('.js-nhdSubmenuClose');
      if (closeSubmenuBtn) {
        const submenu = closeSubmenuBtn.closest('.nhd__submenu');
        if (submenu) closeSubmenu(submenu.id);
      }
    });

    const cards = drawer.querySelector('.nhd__cards');
    if (cards) {
      let isDown = false;
      let startX = 0;
      let startLeft = 0;
      let hasDragged = false;

      cards.addEventListener('mousedown', e => {
        isDown = true;
        hasDragged = false;
        cards.classList.add('dragging');
        startX = e.pageX;
        startLeft = cards.scrollLeft;
      });
      cards.addEventListener('mousemove', e => {
        if (!isDown) return;
        const dx = e.pageX - startX;
        if (Math.abs(dx) > 5) hasDragged = true;
        e.preventDefault();
        cards.scrollLeft = startLeft - dx;
      });
      cards.addEventListener('mouseleave', () => {
        isDown = false;
        cards.classList.remove('dragging');
      });
      cards.addEventListener('mouseup', () => {
        isDown = false;
        cards.classList.remove('dragging');
      });
      cards.addEventListener('click', e => {
        if (hasDragged) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);
    }
  }
}

callOnDocReady(initHeader);
